import { useTranslations } from 'next-intl';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import { CiDeliveryTruck, CiHeadphones } from 'react-icons/ci';
import { LuRefreshCw, LuShieldCheck } from 'react-icons/lu';

const ExtraStores = () => {
  const t = useTranslations('product');

  return (
    <div>
      <div className='grid grid-cols-2 gap-2 sm:grid-cols-4 lg:grid-cols-2'>
        <div className='flex flex-col items-center rounded-lg bg-blue-50 p-2.5 text-center transition-shadow hover:shadow-md'>
          <CiDeliveryTruck size={18} className='mb-1 text-blue-600' />
          <span className='text-xs font-medium'>{t('free_delivery')}</span>
          <span className='flex items-center gap-0.5 text-[10px] text-gray-600'>
            {/* {t('over')} */}
            <span className='flex items-center gap-0.5'>
              100 <CurrencyIcon className='size-2.5' />
            </span>
          </span>
        </div>
        <div className='flex flex-col items-center rounded-lg bg-purple-50 p-2.5 text-center transition-shadow hover:shadow-md'>
          <CiHeadphones size={18} className='mb-1 text-purple-600' />
          <span className='text-xs font-medium'>{t('customer_services')}</span>
          <span className='text-[10px] text-gray-600'>
            {t('customer_services_description')}
          </span>
        </div>
        <div className='flex flex-col items-center rounded-lg bg-green-50 p-2.5 text-center transition-shadow hover:shadow-md'>
          <LuRefreshCw size={18} className='mb-1 text-green-600' />
          <span className='text-xs font-medium'>{t('easy_return')}</span>
          {/* <span className='text-[10px] text-gray-600'>
            {t('easy_return_description')}
          </span> */}
        </div>
        <div className='flex flex-col items-center rounded-lg bg-orange-50 p-2.5 text-center transition-shadow hover:shadow-md'>
          <LuShieldCheck size={18} className='mb-1 text-orange-600' />
          <span className='text-xs font-medium'>{t('Secure Checkout')}</span>
          <span className='text-[10px] text-gray-600'>
            {t('Secure Checkout description')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ExtraStores;
